import { MAP_API_CONFIG } from "../../types/map";
export const searchAddresses = async (query) => {
    if (!query || query.length < 3)
        return [];
    try {
        const response = await fetch(`https://suggest-maps.yandex.ru/v1/suggest?apikey=${MAP_API_CONFIG.geosuggestApiKey}&text=${encodeURIComponent(query)}&results=10&print_address=1`);
        const data = await response.json();
        return data.results.map((item, index) => ({
            value: item.address.formatted_address,
            label: item.address.formatted_address,
            key: `${item.address.formatted_address}-${index}`,
        }));
    }
    catch {
        return [];
    }
};
export const findCoordinates = async (address) => {
    try {
        const response = await fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=${MAP_API_CONFIG.javascriptApiKey}&geocode=${encodeURIComponent(address)}&format=json`);
        const data = await response.json();
        const pos = data.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject?.Point?.pos?.split(" ");
        if (pos) {
            const [lng, lat] = pos.map(Number);
            return [lat, lng];
        }
        return null;
    }
    catch {
        return null;
    }
};
export const defineAddressByCoordinates = async (coordinates) => {
    const [lat, lon] = coordinates;
    try {
        const response = await fetch(`https://geocode-maps.yandex.ru/1.x/?apikey=${MAP_API_CONFIG.javascriptApiKey}&geocode=${lon},${lat}&format=json`);
        const data = await response.json();
        const addressShort = data.response?.GeoObjectCollection?.featureMember?.[0]?.GeoObject
            ?.metaDataProperty?.GeocoderMetaData?.Address?.formatted ||
            `${lat}, ${lon}`;
        return {
            latitude: lat,
            longitude: lon,
            addressShort: addressShort, // Гарантируем string
            addressLocality: addressShort,
        };
    }
    catch {
        const fallback = `${lat}, ${lon}`;
        return {
            latitude: lat,
            longitude: lon,
            addressShort: fallback,
            addressLocality: fallback,
        };
    }
};
